// extracted by mini-css-extract-plugin
export default {"adminAccess":"styles_adminAccess__-Bu6+"};